module.exports = __webpack_public_path__ + "img/check-4-1.bdb85598.png";